import { authorizedApi } from './index';

export const bulkNotificationsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    notifyAppUsersBulk: builder.mutation({
      query: (notificationsData) => ({
        url: '/admin/notify-app-users-bulk',
        method: 'POST',
        body: notificationsData,
      }),
    }),
  }),
});

export const { useNotifyAppUsersBulkMutation } = bulkNotificationsApi;
